"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Tab_1 = tslib_1.__importDefault(require("@material-ui/core/Tab"));
var Tab = function (props) { return (react_1.default.createElement(StyledTab, tslib_1.__assign({}, props, { disableRipple: true, classes: {
        wrapper: 'wrapper',
        disabled: 'disabled',
    } }))); };
exports.default = Tab;
var StyledTab = styled_components_1.default(Tab_1.default)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  && {\n    font-family: ", ";\n    font-size: 1.2rem;\n    letter-spacing: 0.5px;\n    text-decoration: none;\n    margin: 0 2rem;\n    min-width: 0;\n    min-height: 0;\n    padding: 0;\n  }\n  && .wrapper {\n    padding: 0.8rem 0 0.5rem 0;\n  }\n  && .disabled {\n    opacity: 0.4;\n  }\n"], ["\n  && {\n    font-family: ", ";\n    font-size: 1.2rem;\n    letter-spacing: 0.5px;\n    text-decoration: none;\n    margin: 0 2rem;\n    min-width: 0;\n    min-height: 0;\n    padding: 0;\n  }\n  && .wrapper {\n    padding: 0.8rem 0 0.5rem 0;\n  }\n  && .disabled {\n    opacity: 0.4;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoMedium;
});
var templateObject_1;
